import { compile } from 'path-to-regexp';

function getUrlWithParams(path = '/', params = {}) {
  const toPathRaw = compile(path);
  return path === '/' ? path : toPathRaw(params);
}

export default getUrlWithParams;
